import {mock} from './index';

export default {
  getAssetTree: () => mock('/encompassbffservice/encompass-bff/asset-service/v1.0/asset-tree'),
  getAssetAttributes: () => mock('/encompassbffservice/encompass-bff/anti-timeseries/v1.0/attributes'),
  getSystemTime: () => mock('/encompassbffservice/encompass-bff/asset-service/v1.0/timestamp'),
  getCustomizedInfo: () => mock('/encompassbffservice/encompass-bff/persistence-service/v1.0/query-information'),
  setCustomizedInfo: () => mock('/encompassbffservice/encompass-bff/persistence-service/v1.0/insert-information')
};
